module.exports = __webpack_public_path__ + "static/texas_dir_22-0e182f27e029cccd7b65fccb88f22166.jpg";